import * as React from 'react';
import '../../style/sortButton.css';

const arrowDefault = require('../../resource/img/sortup-default.svg');
const arrowFocused = require('../../resource/img/sortup-focused.svg');

interface SortButtonProps {
    clickSort: () => void,
    isFocused?: boolean,
}

class SortButton extends React.Component <SortButtonProps, {}> {
    public render() {
        return (
            <button className="sortButton" onClick={(e) => this.props.clickSort()}>
                <img src={this.props.isFocused ? arrowFocused : arrowDefault}/>
                <img className="cmCollapse" src={this.props.isFocused ? arrowFocused : arrowDefault}/>
            </button>
        );
    }
}

export default SortButton;



// WEBPACK FOOTER //
// ./src/Components/Custom/SortButton.tsx